import PropTypes from "prop-types";
import { Button } from "react-aria-components";
import { useFormState, useWatch } from "react-hook-form";

export const SubmitLink = ({ children, ...props }) => {
	const { isDirty, errors } = useFormState();
	const { firstName, lastName } = useWatch();
	const isLink =
		isDirty &&
		Object.keys(errors).length === 0 &&
		firstName !== "" &&
		lastName !== "";

	const Component = isLink ? "a" : Button;
	const componentProps = isLink
		? {
				href: `/visit/beenverified?fn=${firstName}&ln=${lastName}`,
				target: "_blank",
				rel: "nofollow",
			}
		: { type: "submit" };

	return (
		<Component
			className={`tw:inline-flex tw:w-[144px] tw:cursor-pointer tw:justify-center tw:rounded-lg tw:border-none tw:bg-[#359492] tw:px-6 tw:py-3 tw:font-[inherit] tw:whitespace-nowrap tw:outline-hidden tw:focus-visible:ring-3 tw:focus-visible:ring-blue-500/50 tw:max-lg:w-full tw:max-md:px-4 tw:max-md:py-2 ${!isLink ? "tw:cursor-not-allowed tw:opacity-70" : ""}`}
			isDisabled={!isLink}
			{...componentProps}
			{...props}
		>
			<span className="tw:text-base tw:leading-6 tw:font-semibold tw:text-white">
				{children}
			</span>
		</Component>
	);
};

SubmitLink.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
	isLink: PropTypes.bool,
	data: PropTypes.object,
};
